import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowDownToBracketRound = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.772 13.114a1 1 0 0 1 1 1v3.666h12.001v-3.666a1 1 0 1 1 2 0v4.666a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-4.666a1 1 0 0 1 1-1Zm1.626-3.596a1 1 0 0 1 1.414 0l2.96 2.957V4.78a1 1 0 1 1 2 0v7.7l2.96-2.962a1 1 0 1 1 1.415 1.414l-4.662 4.667a1 1 0 0 1-1.414 0l-4.672-4.667a1 1 0 0 1 0-1.414Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowDownToBracketRound);
export default Memo;
